import { render, staticRenderFns } from "./Few.vue?vue&type=template&id=651fb108&scoped=true&"
import script from "./Few.vue?vue&type=script&lang=js&"
export * from "./Few.vue?vue&type=script&lang=js&"
import style0 from "./Few.vue?vue&type=style&index=0&id=651fb108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651fb108",
  null
  
)

export default component.exports